import useWindowResize from "@/hooks/useWindowResize"
import React, { useEffect, useLayoutEffect, useState } from "react"
import MissingImage from "@/public/images/image-missing.png"

import {
  debounce,
  getPDPPresetUrl,
  getAsPDPThumbnail,
  sanitizeDOMString,
  isObject,
} from "@/utils/helper"

const ProgressiveLoader = props => {
  const { loaderData: pdpDetails = {} } = props
  const { accountName = "" } = pdpDetails
  const [width] = useWindowResize()
  const [imagesData, setImagesData] = useState([])
  const [imageData, setImageData] = useState({})
  const [presetConfig] = useState(JSON.parse(pdpDetails?.presetConfigs ?? "{}"))
  const urlParams = new URLSearchParams(window.location.search)
  const urlSku = sanitizeDOMString(urlParams.get("skuId")) ?? ""

  const { pdpProductCustomerFacingName, productInfoJson } = pdpDetails

  const formatImages = (labels, urls, ResourceCredits, templates) => {
    const images = []
    for (let i = 0; i < urls.length; i++) {
      images.push({
        label: labels[i] ?? "",
        url: isObject(urls[i]) ? urls[i]?.src : urls[i],
        resourceCredits: ResourceCredits[i],
        template: templates[i],
        accountName,
      })
    }
    return images
  }
  useEffect(() => {
    let variantImages = pdpDetails["productImages.labelWithUrl_s"]
      ? pdpDetails["productImages.labelWithUrl_s"]
      : pdpDetails["productImages.labelWithUrl_ss"]
    let selectedSku = pdpDetails["variantList.sku_ss"]
      ? pdpDetails["variantList.sku_ss"][0]
      : urlSku

    let variantImageLabels = [],
      variantImageURLs = [],
      variantImageTemplates = [],
      lifeStyleVariantImageLabels = [],
      variantResourceCredits = [],
      imagesData_ = [],
      lifeStyleVariantResourceCredits = [],
      lifeStyleVariantTemplates = [],
      lifeStyleVariantImageURLs = []

    if (variantImages && variantImages.length > 0) {
      variantImages.map(img => {
        let imgDetail = img.split("|")

        if (selectedSku === imgDetail[0]) {
          variantImageLabels.push(imgDetail[1] + "|" + imgDetail[2])
          variantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "")
          variantImageTemplates.push("LandscapeCategory")
          let _urlIndex = imgDetail.length - 1
          if (
            imgDetail[_urlIndex] &&
            imgDetail[_urlIndex].indexOf("http") > -1
          ) {
            variantImageURLs.push(imgDetail[_urlIndex])
          } else {
            variantImageURLs.push(MissingImage?.src)
          }
        }
        if (imgDetail[0]?.startsWith("IMGV")) {
          lifeStyleVariantImageLabels.push(imgDetail[1] + "|" + imgDetail[2])
          lifeStyleVariantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "")
          lifeStyleVariantTemplates.push("Lifestyle")
          let _urlIndex = imgDetail?.length - 1
          if (
            imgDetail[_urlIndex] &&
            imgDetail[_urlIndex].indexOf("http") > -1
          ) {
            lifeStyleVariantImageURLs.push(imgDetail[_urlIndex])
          } else {
            lifeStyleVariantImageURLs.push(MissingImage?.src)
          }
        }
      })
      if (variantImageURLs.length < 1) {
        variantImageLabels.push(selectedSku)
        variantImageURLs.push(MissingImage?.src)
        variantResourceCredits.push("")
      }
    } else {
      variantImageLabels.push(selectedSku)
      variantImageURLs.push(MissingImage?.src)
      variantResourceCredits.push("")
    }
    imagesData_[selectedSku] = formatImages(
      variantImageLabels,
      variantImageURLs,
      variantResourceCredits,
      variantImageTemplates
    )

    imagesData_["lifeStyleImageVariants"] = formatImages(
      lifeStyleVariantImageLabels,
      lifeStyleVariantImageURLs,
      lifeStyleVariantResourceCredits,
      lifeStyleVariantTemplates
    )

    setImagesData(imagesData_[selectedSku])
  }, [pdpDetails])

  useLayoutEffect(
    debounce(() => {
      const tempImageData = imagesData?.length && {
        ...imagesData[0],
        url: getPDPPresetUrl(
          pdpDetails.swatchUrl,
          presetConfig,
          imagesData[0]?.url || "",
          width,
          imagesData[0]?.template,
          accountName
        ),
      }
      setImageData(tempImageData)
    }),
    [imagesData]
  )

  const getDesignByTitle = () => {
    let productDesignerByText = ""
    if (
      pdpDetails?.pdpDesignerName &&
      pdpProductCustomerFacingName
        .toLowerCase()
        .indexOf(pdpDetails?.pdpDesignerName.toLowerCase()) === -1
    ) {
      productDesignerByText = pdpDetails?.pdpDesignerName
        ? "By" + " " + pdpDetails?.pdpDesignerName
        : ""
    }

    return productDesignerByText
  }

  const productInfoObj = productInfoJson ?? {}
  return (
    <div className="product-detail-page min-vh-100">
      <div className="product-details">
        <div className="container kf-react-container">
          <div className="header-section">
            <div className="product-details__breadcrumb">
              <section>
                <a
                  className="product-details__breadcrumb-link gbh-data-layer"
                  href=""
                >
                  {" "}
                  Home{" "}
                </a>
                /
                <a
                  className="product-details__breadcrumb-link gbh-data-layer"
                  href=""
                >
                  {" "}
                  {pdpDetails?.ProductLocalCategory_s}{" "}
                </a>
              </section>
            </div>
          </div>
          <div className="print-overview product-details__overview-block product-info">
            <div className="product-img-block product-details__image-gallery print-overview-left">
              <div className="image-reel row">
                <div className="image-reel__image-thumb-view no-print">
                  <ul className="pl-0 ml-0 image-reel__image-thumb-view-ul">
                    <li className="image-reel__image-list">
                      <div className="image-reel__image-thumb">
                        <img
                          role="button"
                          src={imageData?.url?.replace("PAWEB", accountName)}
                          className="img-fluid"
                          alt={productInfoObj.pdpImageAlt}
                          tabIndex="0"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="image-reel__image-stack-view">
                  <div className="image-reel__image-stack-view-block">
                    <ul className="pl-0 list-inline image-reel__image-stack-list">
                      <li>
                        <img
                          role="button"
                          // src={pdpDesktopImage}
                          src={imageData?.url?.replace("PAWEB", accountName)}
                          className="print d-none d-sm-block image-reel__stack-list-image"
                          alt={pdpProductCustomerFacingName}
                        />
                        <img
                          role="button"
                          // src={pdpMobileImage}
                          src={imageData?.url?.replace("PAWEB", accountName)}
                          className="print d-sm-none image-reel__stack-list-image"
                          alt={pdpProductCustomerFacingName}
                        />
                      </li>
                    </ul>
                  </div>
                  <p className="image-reel__photo-credit"></p>
                </div>
              </div>
            </div>
            <div className="product-info-block product-details__content-section print-overview-right">
              <div className="col-12 product-summary__product-summary-block p-0">
                <div className="product-summary">
                  <div className="product-summary__desc">
                    <span className="product-summary__desc">
                      {pdpProductCustomerFacingName} {getDesignByTitle()}
                    </span>
                  </div>
                  <div className="product-summary__price">
                    <p className="shimmer-loading__para shimmer height-30"></p>
                  </div>
                  <div className="product-summary__discount">
                    <p className="shimmer-loading__para shimmer height-30"></p>
                  </div>
                  <div className="product-summary__details">
                    <p className="shimmer-loading__para shimmer height-30"></p>
                  </div>
                  <div className="product-summary__button-block">
                    <p className="shimmer-loading__para shimmer height-30"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgressiveLoader
